module.exports = __webpack_public_path__ + "img/bth_bed2_right_yaobu_sel.da599a75.png";